import { Component, OnInit, ElementRef, HostListener, ViewChild ,TemplateRef, OnDestroy} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd  } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Principal } from '../../shared/auth/principal.service';
import { ProjectService } from 'src/app/services/project.service';
import { UserService } from 'src/app/user/user.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { TokenManagementComponent } from '../../shared/utils/components/token-management/token-management.component';
import { ProfileModalComponent } from 'src/app/components/profile-modal/profile-modal.component';

@Component({
	selector: 'app-top-header',
	templateUrl: './top-header.component.html'
})

export class TopHeaderComponent implements OnInit, OnDestroy {

	account: any = {};
	isDropdownOpen = false;
	@ViewChild('dropdownContainer', { static: false }) dropdownContainer!: ElementRef;
@ViewChild(TokenManagementComponent) tokenMgmtComp?: TokenManagementComponent;
@ViewChild('myToken') myTokenRef!: TemplateRef<any>;  // ← add this
    @ViewChild(ProfileModalComponent) profileModal?: ProfileModalComponent;

	projects: any = [];
	selectedProject: string = "";
	showProjectDropdown = false;
	
	isViewRoute: boolean = false; 

	selectedUserToken: any = null;
	isTokenFetching = false;
	tokenConfig = {
		title: 'API Token',
		subtitle: 'Security',
		showExpiryDate: true,
		showLastUsed: true,
		showCreatedDate: true,
		generateButtonText: 'Generate Token',
		revokeButtonText: 'Revoke'
	};
	freshToken = '';
	
	private readonly destroy$ = new Subject<void>();
	
	constructor(
		private principal: Principal,
		private router: Router,
		private projectService: ProjectService,
		private activatedRoute: ActivatedRoute,
		private modelService: NgbModal,
		private toastr: ToastrService,  // ADD THIS
		private userService: UserService
		) { 
		// this.router.events.subscribe(() => {
		// 	// Define routes where the project selection should be shown
		// 	const allowedRoutes = [
		// 		'/data/my', '/data/public',
		// 		'/block/my', '/block/public',
		// 		'/flow/my', '/flow/public',
		// 		'/executions/blocks', '/executions/flows',
		// 		'/flow/view/flow-execute/<some-id>', 'block/view/block-code/<some-id>'
		// 	];
		// 	this.showProjectDropdown = allowedRoutes.includes(this.router.url.split('?')[0]);
		//   });

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(() => {
			// Define routes where the project selection should be shown
			const allowedRoutes = [
				'/data/my', '/data/public',
				'/block/my', '/block/public',
				'/flow/my', '/flow/public',
				'/executions/blocks', '/executions/flows',
				'/home'
			];

			const dynamicRoutePatterns = [
				// Flow routes: /flow/view/flow-info/:id, /flow/view/flow-design/:id, etc.
				/\/flow\/view\/(flow-info|flow-builder|flow-design|flow-execute|flow-dashboard)\/[^/]+/,

				// Block routes: /block/view/block-info/:id, /block/view/block-code/:id
				/\/block\/view\/(block-info|block-code)\/[^/]+/,

				// Data routes: /data/view/:id
				/\/data\/view\/[^/]+/,
			];

			// View pages where the project cannot be changed and is not shown at all.
			const hiddenRoutePatterns = [
				/^\/data\/view\/[^/]+$/,
			];

			const currentUrl = this.router.url.split('?')[0];

			this.isViewRoute = dynamicRoutePatterns.some(pattern => pattern.test(currentUrl));

			this.showProjectDropdown =
				(allowedRoutes.includes(currentUrl) || this.isViewRoute)
				&& !hiddenRoutePatterns.some(pattern => pattern.test(currentUrl));
		});
	}

	ngOnInit() {
		this.principal.identity().then((account) => {
			this.account = account;
			//this.account.full_name = this.account.first_name + this.account.last_name;
			this.account.full_name=account.email;
		});
		this.selectedProject = localStorage.getItem('project_id') || ""; // Load from storage

		this.projectService.project$.subscribe(projectId => {
			this.selectedProject = projectId || "";
		});

		this.projectService.projectDeleted
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (id: string) => {
					this.loadProjects();
					if (this.selectedProject === id) {
						this.selectedProject = '';
						this.projectService.setProject('');
					}
				}
			});

		this.projectService.projectCreated
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (id: string) => {
					this.loadProjects();
					this.selectedProject = id;
					this.projectService.setProject(id);
				}
			});

		this.loadProjects();
	}

	hasTokenPermission(): boolean {
		const roles = this.account?.roles || [];
		const permissions = this.account?.permissions || [];
		
		if (roles.includes('ADMIN')) return true;
		
		const permList = Array.isArray(permissions) 
			? permissions 
			: permissions.split(',').map((p: string) => p.trim());
		
		return permList.includes('TOKEN');
	}

	logout() {
		localStorage.removeItem("access_token");
		localStorage.removeItem("refresh_token");
		localStorage.removeItem("user_id");
		localStorage.removeItem("username");
		localStorage.removeItem("roles");
		localStorage.removeItem("resetEmailCooldown"); 
	
		this.projectService.clearProject();
		this.profileModal?.resetCooldown();
		
		this.router.navigate(['/login']);
	}

	toggleDropdown(event: Event): void {
		event.preventDefault();
		this.isDropdownOpen = !this.isDropdownOpen;
	  }
	
	  @HostListener('document:click', ['$event'])
	  closeDropdown(event: Event): void {
		if (this.dropdownContainer && !this.dropdownContainer.nativeElement.contains(event.target)) {
		  this.isDropdownOpen = false;
		}
	  }

	  setProject() {
		this.projectService.setProject(this.selectedProject); // Broadcast change
	  }

	  loadProjects() {
		this.projectService.getUserProjects({limit: 1000}).subscribe((response) => {

		this.projects = [
			{ _id: "", name: 'Default Project', code: 'Default' }, // Default Option
			...response.rows.map((item: any) => item.project)
			];	
		});
	  }

	onProjectCreated(id: string) {
		this.projectService.notifyCreate(id);
	}

	onProfileUpdated(data: { first_name: string; last_name: string }) {
		this.account.first_name = data.first_name;
		this.account.last_name = data.last_name;
		this.account.full_name = data.first_name + data.last_name;
	}

	openTokenModal(myToken: any): void {
    this.selectedUserToken = null;
    this.freshToken = '';
    this.loadUserToken();
    this.modelService.open(myToken, { centered: true, size: 'md' });
}
	loadUserToken(): void {
		if (!this.account?._id) return;
		this.isTokenFetching = true;
		this.userService.getTokenByUser(this.account._id).subscribe({
			next: (res) => {
				this.selectedUserToken = res ?? null;
				this.isTokenFetching = false;
			},
			error: () => {
				this.selectedUserToken = null;
				this.isTokenFetching = false;
			}
		});
	}

	handleGenerateToken(user: any): void {
    this.isTokenFetching = true;
    this.userService.generateToken(this.account._id).subscribe({
        next: (res) => {
    this.isTokenFetching = false;
    const data = res.token; // ← unwrap nested object
    this.freshToken = data.token;
    this.selectedUserToken = { ...data, is_active: true };
},
        error: () => {
            this.isTokenFetching = false;
            this.toastr.error('Failed to generate token', 'Error');
        }
    });
}

	handleRevokeToken(user: any): void {
		this.isTokenFetching = true;
		this.userService.revokeToken(this.account._id).subscribe({
			next: () => {
				this.selectedUserToken = null;
				this.isTokenFetching = false;
				this.toastr.success('Token revoked', 'Success');
			},
			error: () => { this.isTokenFetching = false; }
		});
	}

	ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
